import { Box, Image, Heading, Grid, GridItem, Flex } from "@chakra-ui/react";
import React from "react";

import flower from "../../../assets/home/flower.png";
import leftStickerBg from "../../../assets/home/rec.png";
import leftStickerIcon from "../../../assets/home/imonrec.png";
import rightStickerBg from "../../../assets/home/ycicrcle.png";
import rightStickerIcon from "../../../assets/home/imoncircle.png";

import testimonial1 from "../../../assets/home/r1.png";
import testimonial2 from "../../../assets/home/r2.png";
import testimonial3 from "../../../assets/home/r3.png";
import testimonial4 from "../../../assets/home/r4.png";
import testimonial5 from "../../../assets/home/r5.png";
import testimonial6 from "../../../assets/home/r6.png";
import grey from "../../../assets/flower/greyish.png";
import grey1 from "../../../assets/flower/greyish.png";
import cream from "../../../assets/flower/cream.png";
import FlowerImage from "component/FlowerImage";
import traditionalleft from "../../../assets/home/ourProcess/traditionalleft.png";
import traditionalright from "../../../assets/home/ourProcess/traditionalright.png";

const Ourprocess = () => {
  const testimonials = [
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,
    testimonial5,
    testimonial6,
  ];

  return (
    <Box
      bg="#005770"
      pb={{ base: 10, md: 20 }}
      color="white"
      position="relative"
    >
      <Image
        src={traditionalleft}
        width={{ base: "100px", md: "170px" }}
        display={{ base: "none", md: "block" }}
      />
      <Image
        src={traditionalright}
        top={"0"}
        right={"0"}
        position={"absolute"}
        display={{ base: "none", md: "block" }}
        width={{ base: "100px", md: "170px" }}
      />
      <FlowerImage
        src={cream}
        top={{ base: "10px", md: "5%" }}
        right={{ base: "10%", md: "30%" }}
      />
      <FlowerImage
        src={grey}
        top={{ base: "9%", md: "20%" }}
        left={{ base: "10%", md: "25%" }}
      />
      <FlowerImage
        src={grey1}
        top={{ base: "96%", md: "90%" }}
        right={{ base: "25%", md: "18%" }}
      />

      {/* Heading Section with Left and Right Stickers */}
      <Flex
        justify="space-between"
        align="center"
        position="relative"
        width={"100%"}
        px={{ base: 4, md: 8 }}
        mb={{ base: 10, md: 4 }}
      >
        {/* Left Sticker */}
        <Box position="relative">
          <Image
            src={leftStickerBg}
            maxW={{ base: "100px", md: "170px" }}
            data-animated="true"
            display={{ base: "none", md: "block" }}
          />
          <Image
            src={leftStickerIcon}
            position="absolute"
            top={{ base: "15px", md: "36px" }}
            left="18px"
            maxW="30px"
            display={{ base: "none", md: "block" }}
            data-animated="true"
          />
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            display={{ base: "none", md: "block" }}
          >
            <Heading
              fontSize={{ base: "xs", md: "sm" }}
              color="white"
              fontWeight="medium"
              textAlign="center"
            >
              From Our <br /> Clients
            </Heading>
          </Box>
        </Box>

        <Box
          position="relative"
          width={"100%"}
          textAlign="center"
          mb={{ base: 0, md: 4 }}
          mt={{ base: "20px", md: "-20px" }}
          minH={{ base: "150px", md: "200px" }}
          ml={{ base: "10px", md: "-110px" }} // ✅ Add height
        >
          <Image
            src={flower}
            alt="Flower"
            maxW="200px"
            mx="auto"
            className="fade-in-up"
          />
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            width="100%" // optional: ensures text stays centered
          >
            <Heading
              fontSize={{ base: "xl", md: "3xl" }}
              fontWeight="bold"
              className="fade-in-up"
            >
              Hear It From Those <br />
              <Box
                as="span"
                color="#BFA585"
                fontStyle="italic"
                className="fade-in-up"
              >
                Who Matter Most
              </Box>
            </Heading>
          </Box>
        </Box>

        {/* Right Sticker */}
        <Box position="relative">
          <Image
            src={rightStickerBg}
            maxW={{ base: "60px", md: "70px" }}
            data-animated="true"
            display={{ base: "none", md: "block" }}
          />
          <Image
            src={rightStickerIcon}
            position="absolute"
            top="15px"
            right="20px"
            maxW="30px"
            display={{ base: "none", md: "block" }}
            data-animated="true"
          />
          <Box
            mt={2}
            textAlign="center"
            display={{ base: "none", md: "block" }}
          >
            <Heading
              fontSize={{ base: "xs", md: "sm" }}
              color="white"
              fontWeight="medium"
            >
              asli feedback
            </Heading>
          </Box>
        </Box>
      </Flex>

      {/* Testimonials Grid */}
      <Grid
        templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }}
        gap={{ base: 3, md: 4 }}
        px={{ base: 4, md: 32 }}
        maxW="1060px"
        mx="auto"
      >
        {testimonials.map((img, idx) => (
          <GridItem key={idx} display="flex" justifyContent="center">
            <Image
              className="fade-in-up"
              src={img}
              maxW="260px"
              w="100%"
              borderRadius="lg"
              boxShadow="md"
            />
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};

export default Ourprocess;
